import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export interface IAnswerMapping {
  key: string
  item_id: string
  question_id?: string
}

export class QrOptionsVM extends CommonOptionVM {
  required?: boolean
  populate_answers?: boolean
  answer_mappings?: IAnswerMapping[]

  constructor(data: Partial<QrOptionsVM> = {}) {
    super(data)
    this.required = data.required ?? undefined
    this.populate_answers = data.populate_answers ?? undefined
    this.answer_mappings = data.answer_mappings ?? undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default QrOptionsVM